import React, { Component } from 'react';
import { Link } from 'gatsby';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
import { css } from '@emotion/react';

const DropdownCss = css`
  alignSelf: flex-end;
`;

const DropdownToggleCss = css`
  display: block;
  color: #fff;
  cursor: pointer;
`;

const DropdownToggleItemCss = css`
  display: flex;
  align-items: center;
`;

const DropdownToggleItemTextCss = css`
  margin-left: 0.5rem;
  color: #ffffff;
`;

const DropdownToggleItemTextDarkCss = css`
  margin-left: 0.5rem;
`;

const DropdownToggleImgCss = css`
  border: 1px solid #ffffffaa;
`;

const DropdownToggleIconCss = css`
  margin-left: 0.5rem;
  color: #fff;
`;

const DropdownToggleIconDarkCss = css`
  margin-left: 0.5rem;
  color: #282c2f;
`;

export default class LanguageDropdown extends Component {

  render() {
    let { language, refs, dark, ...props } = this.props;
    let links = refs.filter(
      (ref) => (ref.language.name !== language.name)
    ).sort(
      (a, b) => a.name.localeCompare(b.name)
    );
    return (
      <UncontrolledDropdown css={DropdownCss} {...props}>
        <DropdownToggle tag="a" css={DropdownToggleCss}>
          <div css={DropdownToggleItemCss}>
            <img css={DropdownToggleImgCss} src={language.flag.localFile.publicURL} alt={language.label} />
            <span css={dark ? DropdownToggleItemTextDarkCss : DropdownToggleItemTextCss}>{language.label}</span>
            <FontAwesomeIcon
              css={dark ? DropdownToggleIconDarkCss : DropdownToggleIconCss}
              icon={faCaretDown}
            />
          </div>
        </DropdownToggle>
        <DropdownMenu right>
          {
            links.map((link, i) => <LanguageDropdownItem key={`lang-${i}`} link={link} />)
          }
        </DropdownMenu>
      </UncontrolledDropdown>
    );
  }

}

export function LanguageDropdownItem ({ link }) {
  return (
    <DropdownItem tag={Link} to={link.url}>
      <img src={link.language.flag.localFile.publicURL} alt={link.language.label} />
      <span css={css`margin-left: 0.5rem;`}>
        {link.language.label}
      </span>
    </DropdownItem>
  );
}